import SectionLabel from "./SectionLabel";
import { Reveal } from "./Reveal";

function Credit({ children }) {
    return (
        <li className="flex gap-4 text-sm leading-relaxed text-cream/75">
            <span
                aria-hidden="true"
                className="mt-[9px] h-1 w-1 shrink-0 rotate-45 bg-gold"
            />
            <span>{children}</span>
        </li>
    );
}

export default function Founders() {
    return (
        <section
            id="founders"
            data-testid="founders-section"
            className="scroll-mt-20 px-6 py-28 sm:py-36"
        >
            <div className="mx-auto max-w-6xl">
                <SectionLabel id="founders">Founders</SectionLabel>
                <div className="mt-14 grid gap-6 lg:grid-cols-2">
                    <Reveal>
                        <article
                            data-testid="founder-card-bsr"
                            className="card-lift h-full border border-cream/10 bg-coal/50 p-8 hover:border-gold/40 sm:p-10"
                        >
                            <div className="flex items-start justify-between">
                                <p className="font-label text-[10px] uppercase tracking-[0.45em] text-gold">
                                    Producer
                                </p>
                                <span className="font-display text-3xl italic text-cream/20">
                                    01
                                </span>
                            </div>
                            <h3 className="mt-7 font-display text-3xl font-light text-cream sm:text-4xl">
                                B. S. Radhakrishnan
                            </h3>
                            <p className="mt-3 text-sm text-cream/60">
                                Third-generation entertainment professional ·
                                Credits across 50+ features
                            </p>
                            <div
                                className="my-8 h-px bg-gradient-to-r from-gold/50 to-transparent"
                                aria-hidden="true"
                            />
                            <div className="space-y-4 text-[15px] leading-relaxed text-cream/75">
                                <p>
                                    He has held leadership roles at Radaan
                                    Mediaworks, Southern Digital Screenz (the
                                    South Indian arm of UFO Moviez), KSS Ltd.,
                                    Kavi Puvi Viamedia and many more.
                                </p>
                                <p>
                                    In Southeast Asia, he handled content
                                    aggregation and syndication for ASTRO and
                                    produced events in Kuala Lumpur and
                                    Singapore — including IIFA, ITFA 2003 /
                                    2004 and Nadigar Sangam shows.
                                </p>
                            </div>
                            <div className="mt-9">
                                <p className="font-label text-[9px] uppercase tracking-[0.45em] text-cream/40">
                                    Selected individual credits
                                </p>
                                <ul className="mt-5 space-y-3">
                                    <Credit>
                                        <span className="font-display text-base text-cream">
                                            A Common Man
                                        </span>{" "}
                                        — produced by B. S. Radhakrishnan; won
                                        Best Picture, Best Director and Best
                                        Actor at the Madrid International Film
                                        Festival.
                                    </Credit>
                                </ul>
                            </div>
                        </article>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <article
                            data-testid="founder-card-pranav"
                            className="card-lift h-full border border-cream/10 bg-coal/50 p-8 hover:border-gold/40 sm:p-10"
                        >
                            <div className="flex items-start justify-between">
                                <p className="font-label text-[10px] uppercase tracking-[0.45em] text-gold">
                                    Founder
                                </p>
                                <span className="font-display text-3xl italic text-cream/20">
                                    02
                                </span>
                            </div>
                            <h3 className="mt-7 font-display text-3xl font-light text-cream sm:text-4xl">
                                Pranav Radhakrishnan
                            </h3>
                            <p className="mt-3 text-sm text-cream/60">
                                Founded and leads Mountain View Pictures
                            </p>
                            <div
                                className="my-8 h-px bg-gradient-to-r from-gold/50 to-transparent"
                                aria-hidden="true"
                            />
                            <div className="space-y-4 text-[15px] leading-relaxed text-cream/75">
                                <p>
                                    He works across international
                                    co-production, structuring, financing and
                                    partnerships — shaping projects that begin
                                    in Chennai and travel outward.
                                </p>
                            </div>
                            <div className="mt-9">
                                <p className="font-label text-[9px] uppercase tracking-[0.45em] text-cream/40">
                                    Selected individual credits
                                </p>
                                <ul className="mt-5 space-y-3">
                                    <Credit>
                                        <span className="font-display text-base text-cream">
                                            Rihana
                                        </span>{" "}
                                        — Tamil feature; Cannes Official
                                        Selection, Marché du Film Gala.
                                    </Credit>
                                    <Credit>
                                        Commercial background at Freshworks,
                                        Zomato and EY.
                                    </Credit>
                                </ul>
                            </div>
                        </article>
                    </Reveal>
                </div>
                <Reveal delay={0.15}>
                    <p className="mt-8 text-xs tracking-wide text-cream/40">
                        Rihana and A Common Man are the founders&rsquo;
                        individual credits — not Mountain View Pictures
                        productions.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
